import Button from "@components/Button";
import Dialog from "@components/Dialog";
import { Row } from "@components/Layout";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import { type JSX, type ParentComponent, Show } from "solid-js";

const ConfirmDelete: ParentComponent<{
	onConfirm: () => void;
	confirmText: JSX.Element;
	open?: boolean;
	onOpenChange?: (open: boolean) => void;
}> = (props) => {
	const { t } = useI18n();
	return (
		<Dialog
			openTrigger={props.children}
			title={`${t("global.delete")} ?`}
			buttonsSlot={<Button onclick={props.onConfirm}>{t("global.delete")}</Button>}
			open={props.open}
			onOpenChange={props.onOpenChange}
		>
			<Row>
				<Show when={typeof props.confirmText === "string"} fallback={props.confirmText}>
					<Row justifyContent="center" padding="15px 0">
						<h3 style={{ "text-align": "center" }}>{props.confirmText}</h3>
					</Row>
				</Show>
			</Row>
		</Dialog>
	);
};
export default ConfirmDelete;
